import React from "react"
import { MenuButtonProvider, ScrollPositionProvider } from "./src/contexts"

export const wrapRootElement = ({ element }) => (
  <MenuButtonProvider>
    <ScrollPositionProvider>{element}</ScrollPositionProvider>
  </MenuButtonProvider>
)
